import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

export enum UserTypes {
  Company = 'Company',
  Location = 'Location'
}

// Configure request setup
const serviceName = 'ApiKeyService'
const host = `${servicesConfig.Oauth}/keys`
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const ApiKeyService = {
  createLocationKey: (locationId: string) => 
    request().post(`/location/${locationId}`, {}).then(responseBody),
    
  createCompanyKey: (companyId: string, title: string) => 
    request().post(`/agency/${companyId}`, {title}).then(responseBody),
    
  updateCompanyKey: (id: string, title: string) => 
    request().put(`/${id}`, {title}).then(responseBody),
    
  deleteCompanyKey: (id: string) => 
    request().delete(`/${id}`).then(responseBody),
    
  getAllLocationKeysByCompanyId: (companyId: string, limit = 5, skip = 0, queryString?: string) => {
    let query = `?limit=${limit}&skip=${skip}`
    if(queryString?.length){
      query += `${query}&query=${queryString}`
    }
    return request().get(`/${companyId}/all${query}`).then(responseBody)
  },
  
  getKeys: (accountId: string, type: UserTypes, limit = 5, skip = 0) => {
    const query = `?accountId=${accountId}&type=${type}&limit=${limit}&skip=${skip}`
    return request().get(`/${query}`).then(responseBody)
  },
  
  getLocationKey: (locationId: string) => 
    request().get(`/location/${locationId}`).then(responseBody),
    
  deleteAllKey: (companyId: string) => 
    request().delete(`/${companyId}/all`, {}).then(responseBody),
    
  deleteLocationKey: (locationId: string) => 
    request().delete(`/location/${locationId}`, {}).then(responseBody)
}
  
export default ApiKeyService